import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
  AllocateRequest, Allocation, AllocationCreditType, AllocationSide, AllocationTargetType, OpenCredit,
} from '../interfaces/allocation.interface';

export const AllocationService = {
  allocate: async (dto: AllocateRequest): Promise<Allocation> =>
    (await axios.post(ENDPOINTS.ALLOCATION.CREATE, dto)).data,
  reverse: async (id: string): Promise<Allocation> =>
    (await axios.post(ENDPOINTS.ALLOCATION.REVERSE(id))).data,
  forCredit: async (type: AllocationCreditType, id: string): Promise<Allocation[]> =>
    (await axios.get(ENDPOINTS.ALLOCATION.FOR_CREDIT(type, id))).data,
  forTarget: async (type: AllocationTargetType, id: string): Promise<Allocation[]> =>
    (await axios.get(ENDPOINTS.ALLOCATION.FOR_TARGET(type, id))).data,
  openCredits: async (institutionId: string, partyId: string, side: AllocationSide): Promise<OpenCredit[]> =>
    (await axios.get(ENDPOINTS.ALLOCATION.OPEN_CREDITS, { params: { institutionId, partyId, side } })).data,
};
